import { render } from "./like-react-form.vue?vue&type=template&id=6d862718&ts=true"
import script from "./like-react-form.vue?vue&type=script&lang=ts"
export * from "./like-react-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__